import { useUser } from '@liveblocks/react'

export default function NotificationResolvedUserName({
  userId,
  className,
}: {
  userId: string
  className?: string
}) {
  const { user } = useUser(userId)

  return user ? (
    <span className={className}>{user.name}</span>
  ) : (
    <div className='tw-w-32 tw-h-6 tw-animate-skeleton-shimmer tw-inline-block' />
  )
}
